export const SAVE_PERSONAS = "SAVE_PERSONAS"
export const CLEAR_PERSONAS = "CLEAR_PERSONAS"